import {useContext} from 'react'
import {CustomerContext} from '../CustomerContext'
import {Card} from '@/components/Card'
import SponsorshipForm from './forms/SponsorshipForm'
import {DateRangeProvider} from '@/components/context/DateRangeContext'
import SponsorshipReportPane from './panes/SponsorshipReportPane'

const Sponsorship = () => {
  const { customer } = useContext(CustomerContext)

  if (!customer || !customer.sponsorship) {
    return (<></>)
  }

  return (
    <>
      <Card
        title="Settings"
        collapsable={true}
        collapse={true}
        id="sponsorship"
      >
        <SponsorshipForm
          customerId={customer._id}
          sponsorship={customer.sponsorship}
        />
      </Card>
      <DateRangeProvider
        defaultRange="month"
        minDate={new Date(customer.createdAt)}
        maxDate={new Date()}
      >
        <SponsorshipReportPane />
      </DateRangeProvider>
    </>
  )
}

export default Sponsorship
